import { superFetch, asyncCheckStatus } from 'helpers/apiConf'
import { Country } from 'api/types'

export async function getCountries() {
  const resp = await superFetch({
    url: `pays`,
  })
  const data = await asyncCheckStatus(resp)
  return data as Array<Country>
}